import createIcon from '../../createIcon';

/**
 * @component @name AddAlarm
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy44OCAzLjQ1OTY5TDYuNiAxLjkyOTY5TDIgNS43Nzk2OUwzLjI5IDcuMzA5NjlMNy44OCAzLjQ1OTY5Wk0yMiA1Ljc4OTY5TDE3LjQgMS45Mjk2OUwxNi4xMSAzLjQ1OTY5TDIwLjcxIDcuMzE5NjlMMjIgNS43ODk2OVpNMTIgNC4wNjk2OUM3LjAzIDQuMDY5NjkgMyA4LjA5OTY5IDMgMTMuMDY5N0MzIDE4LjAzOTcgNy4wMiAyMi4wNjk3IDEyIDIyLjA2OTdDMTYuOTcgMjIuMDY5NyAyMSAxOC4wMzk3IDIxIDEzLjA2OTdDMjEgOC4wOTk2OSAxNi45NyA0LjA2OTY5IDEyIDQuMDY5NjlaTTEyIDIwLjA2OTdDOC4xMyAyMC4wNjk3IDUgMTYuOTM5NyA1IDEzLjA2OTdDNSA5LjE5OTY5IDguMTMgNi4wNjk2OSAxMiA2LjA2OTY5QzE1Ljg3IDYuMDY5NjkgMTkgOS4xOTk2OSAxOSAxMy4wNjk3QzE5IDE2LjkzOTcgMTUuODcgMjAuMDY5NyAxMiAyMC4wNjk3Wk0xMyA5LjA2OTY5SDExVjEyLjA2OTdIOFYxNC4wNjk3SDExVjE3LjA2OTdIMTNWMTQuMDY5N0gxNlYxMi4wNjk3SDEzVjkuMDY5NjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddAlarm = createIcon('AddAlarm', [
  [
    'path',
    {
      d: 'M7.88 3.45969L6.6 1.92969L2 5.77969L3.29 7.30969L7.88 3.45969ZM22 5.78969L17.4 1.92969L16.11 3.45969L20.71 7.31969L22 5.78969ZM12 4.06969C7.03 4.06969 3 8.09969 3 13.0697C3 18.0397 7.02 22.0697 12 22.0697C16.97 22.0697 21 18.0397 21 13.0697C21 8.09969 16.97 4.06969 12 4.06969ZM12 20.0697C8.13 20.0697 5 16.9397 5 13.0697C5 9.19969 8.13 6.06969 12 6.06969C15.87 6.06969 19 9.19969 19 13.0697C19 16.9397 15.87 20.0697 12 20.0697ZM13 9.06969H11V12.0697H8V14.0697H11V17.0697H13V14.0697H16V12.0697H13V9.06969Z',
      key: '1qtid1',
    },
  ],
]);

export default AddAlarm;
